import styled from "styled-components";
import { Form as Unform } from '@unform/web';

export const EmailForm = styled(Unform)`
  width: 70%;
  margin: 64px 32px;
  display: grid;

  h1 {
    font-size: 2.8rem;
    color: #fff;
    text-align: center;
    font-family: 'GothamBold';
  }

  p {
    font-size: 1.6rem;
    color: #fff;
    font-family: 'GothamBook';
    margin-top: 16px;
    margin-bottom: 32px
  }

  span {
    font-size: 1.6rem;
    color: #fff;
    font-family: 'GothamBold';
  }

  @media (max-width: 1200px) {
    width: 85%;
  }
`;

export const SubmitButton = styled.button`
  background: var(--primary);
  border: none;
  border-radius: 4px;
  padding: 10px 4px;
  width: 100%;
  margin: 10px auto;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
  transition: all 0.5s;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    cursor: wait;
    background-color: #ccc;
  }
`;

export const TimerText = styled.p`
    text-align: center,
    font-size: 1.6rem;
    color: #fff;
    font-family: 'GothamBook';
    margin-top: 16px;
    margin-bottom: 32px
`

export const ResendOtpButton = styled.button`
    background: var(--primary);
    border: none;
    border-radius: 4px;
    padding: 10px 8px;
    width: max-content;
    margin: 0 auto 32px auto;
    text-transform: uppercase;
    color: #fff;
    cursor: pointer;
    transition: all 0.5s;
    &:hover:not([disabled]) {
        opacity: 0.8;
    }
    &:disabled {
        cursor: not-allowed;
        background-color: #ccc;
    }
`